import { useSelector } from 'react-redux';

import useDispatchOnMount from '../../../../hooks/useDispatchOnMount';
import OrganizationsModule from '../../../../redux/organizations';
import { selectOptionFactory } from '../../../../utils';
import type { SelectOption } from '../../../../types';

/**
 * Fetches the list of labels available to the organization.
 */
const useOrgLabels = (): { isLoading: boolean; labels: SelectOption[]; } => {
  useDispatchOnMount(OrganizationsModule.actions.fetchOrgLabels);

  const status = useSelector(OrganizationsModule.selectors.getOrganizationLabelsStatus);
  const labels = useSelector(OrganizationsModule.selectors.getOrganizationLabels);
  const labelOptions = labels.map((label) => selectOptionFactory(label.label, label.label));

  return { isLoading: status.isLoading, labels: labelOptions };
};

export default useOrgLabels;
